// First-entry welcome screen. It remains visible until the page is fully loaded,
// holds for a calm presentation beat, then fades once per browsing session.
(function initWelcomeScreen() {
  const preloader = document.getElementById('preloader');
  if (!preloader) return;

  const welcomeKey = 'jb-welcome-seen';
  const holdAfterLoad = 3000;
  const fadeDuration = 700;
  const maxWelcomeDuration = 10000;
  const welcomeStartedAt = Date.now();
  let welcomeFinishing = false;
  let fadeStarted = false;
  let finishTimer;
  let safetyTimer;

  if (document.documentElement.classList.contains('jb-welcome-seen')) {
    preloader.remove();
    return;
  }

  function completeWelcome() {
    try {
      window.sessionStorage.setItem(welcomeKey, '1');
    } catch (error) {
      document.cookie = welcomeKey + '=1; path=/; SameSite=Lax';
    }
    document.documentElement.classList.remove('jb-welcome-active');
    document.documentElement.classList.add('jb-welcome-seen');
    preloader.remove();
  }

  function beginWelcomeFade() {
    if (fadeStarted) return;
    fadeStarted = true;
    welcomeFinishing = true;
    window.clearTimeout(finishTimer);
    window.clearTimeout(safetyTimer);
    preloader.classList.add('is-hiding');
    window.setTimeout(completeWelcome, fadeDuration);
  }

  function finishWelcome() {
    if (welcomeFinishing) return;
    welcomeFinishing = true;
    const elapsed = Date.now() - welcomeStartedAt;
    const availableHold = Math.max(0, maxWelcomeDuration - fadeDuration - elapsed);
    finishTimer = window.setTimeout(beginWelcomeFade, Math.min(holdAfterLoad, availableHold));
  }

  function finishWhenReady() {
    const fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    fontsReady.catch(function () {}).then(finishWelcome);
  }

  if (document.readyState === 'complete') {
    finishWhenReady();
  } else {
    window.addEventListener('load', finishWhenReady, { once: true });
  }

  // Never strand a visitor behind the welcome screen if a third-party asset stalls.
  safetyTimer = window.setTimeout(beginWelcomeFade, maxWelcomeDuration - fadeDuration);
})();

// Product recommendation tabs.
document.addEventListener('DOMContentLoaded', function () {
document.querySelectorAll('.cus-prd-coll-tbs-bv--section').forEach((section) => {
  section.flickityInstances = {};
  section.querySelectorAll('.cus-prd-coll-tbs-bv--pane .js-flickity').forEach(slider => {
    const pane = slider.closest('.cus-prd-coll-tbs-bv--pane');
    if (!pane || !window.Flickity) return;
    const wasHidden = pane.style.display === 'none' || getComputedStyle(pane).display === 'none';
    if (wasHidden) pane.style.display = 'block';

    let options = {};
    try {
      options = JSON.parse(slider.dataset.flickity || '{}');
    } catch (error) {
      console.warn('Invalid Flickity options; using defaults.', error);
    }
    section.flickityInstances[pane.id] = Flickity.data(slider) || new Flickity(slider, options);
    if (wasHidden) pane.style.display = '';
  });

  section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach((tab) => {
    tab.addEventListener('click', function () {
      section.querySelectorAll('.cus-prd-coll-tbs-bv--tab').forEach(t => t.classList.remove('active'));
      section.querySelectorAll('.cus-prd-coll-tbs-bv--pane').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const activePane = document.getElementById(this.dataset.tab);
      if (!activePane || !section.contains(activePane)) return;
      activePane.classList.add('active');
      if (section.flickityInstances[activePane.id]) {
        section.flickityInstances[activePane.id].resize();
      }
    });
  });
});
});

// ---------------------------------------------icon phone header---------------------------------

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector(".cus_phn_em_cnt__drawer");
  const overlay = document.querySelector(".cus_phn_em_cnt__overlay");
  if (!drawer || !overlay) return;
  const contactClose = drawer.querySelector(".cus_phn_em_cnt__close");
  let contactOpenedBy = null;
  let contactCloseTimer = null;
  document.querySelectorAll(".cus_cnt_em_us_icn").forEach(btn => {
    btn.addEventListener("click", () => {
      window.clearTimeout(contactCloseTimer);
      contactOpenedBy = btn;
      document.dispatchEvent(new CustomEvent('jb:contact-open'));
      drawer.classList.remove("closing");
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add("active");
      overlay.classList.add("active");
      document.body.classList.add('jb-contact-open');
      contactClose?.focus({ preventScroll: true });
    });
  });

  const closeDrawer = () => {
    if (!drawer.classList.contains('active')) return;
    drawer.classList.remove("active");
    drawer.classList.add("closing");
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove("active");
    window.clearTimeout(contactCloseTimer);
    contactCloseTimer = window.setTimeout(() => {
      drawer.classList.remove("closing");
      drawer.setAttribute('inert', '');
      document.body.classList.remove('jb-contact-open');
      contactOpenedBy?.focus({ preventScroll: true });
      contactOpenedBy = null;
    }, 650);
  };

  contactClose?.addEventListener("click", closeDrawer);
  overlay.addEventListener("click", closeDrawer);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  document.querySelectorAll("[data-acc]").forEach(item => {
    item.addEventListener("click", () => {
      const parent = item.closest(".cus_phn_em_cnt__item");
      const icon = item.querySelector(".cus_phn_em_cnt__icon");

      document.querySelectorAll(".cus_phn_em_cnt__item").forEach(acc => {
        if (acc !== parent) {
          acc.classList.remove("active");
          const otherIcon = acc.querySelector(".cus_phn_em_cnt__icon");
          if (otherIcon) otherIcon.textContent = "+";
          const otherButton = acc.querySelector('[data-acc]');
          const otherBody = acc.querySelector('.cus_phn_em_cnt__item-body');
          otherButton?.setAttribute('aria-expanded', 'false');
          if (otherBody) otherBody.hidden = true;
        }
      });

      if (!parent || !icon) return;
      parent.classList.toggle("active");
      const isActive = parent.classList.contains("active");
      item.setAttribute('aria-expanded', String(isActive));
      const body = parent.querySelector('.cus_phn_em_cnt__item-body');
      if (body) body.hidden = !isActive;
      icon.textContent = isActive ? "−" : "+";
    });
  });

});


// {% comment %} --------------------------------------customizer product custom block------------------------------------ {% endcomment %}

document.addEventListener('DOMContentLoaded', function(){
  const wrapper = document.querySelector('.cus_drw_cst_prd_blk_wrapper');
  if(!wrapper) return;
  const drawer = wrapper.querySelector('.cus_drw_cst_prd_blk_drawer');
  const overlay = wrapper.querySelector('.cus_drw_cst_prd_blk_overlay');
  const messageField = wrapper.querySelector('.cus_drw_cst_prd_blk_message_field');
  const openButton = wrapper.querySelector('.cus_drw_cst_prd_blk_btn');
  const closeButton = wrapper.querySelector('.cus_drw_cst_prd_blk_close');
  const confirmButton = wrapper.querySelector('.cus_drw_cst_prd_blk_confirm');
  const fontInput = wrapper.querySelector('.cus_drw_cst_prd_blk_font_input');
  const symbolInput = wrapper.querySelector('.cus_drw_cst_prd_blk_symbol_input');
  if (!drawer || !overlay || !messageField || !openButton || !closeButton || !confirmButton || !fontInput || !symbolInput) return;
  let selectedFont = '';
  /* drawer open */
  openButton.addEventListener('click', function(){
    drawer.classList.add('active');
    overlay.classList.add('active');
  });
  /* drawer close */
  function closeDrawer(){
    drawer.classList.remove('active');
    overlay.classList.remove('active');
  }
  closeButton.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);

  /* font select */
    const fontButtons = wrapper.querySelectorAll('.cus_drw_cst_prd_blk_font_btn');
		if(fontButtons.length){
		fontButtons[0].classList.add('active');
		selectedFont = fontButtons[0].dataset.value;
		}
		fontButtons.forEach(btn => {
		btn.addEventListener('click', function(){

			fontButtons.forEach(item => {
			item.classList.remove('active');
			});
			this.classList.add('active');
			selectedFont = this.dataset.value;
		});
		});
  /* symbol click → directly add into input (max 7) */
  wrapper.querySelectorAll('.cus_drw_cst_prd_blk_symbol_btn').forEach(btn => {

    btn.addEventListener('click', function(){

      let symbol = this.dataset.value;
      let currentValue = messageField.value;

      if(currentValue.length < 7){
        messageField.value = currentValue + symbol;
      }
    });
  });
  /* manual input max 7 */
  messageField.addEventListener('input', function(){

    if(this.value.length > 7){
      this.value = this.value.slice(0, 7);
    }

  });
  /* confirm */
  confirmButton.addEventListener('click', function(){
  const messageValue = messageField.value;
  fontInput.value = selectedFont;
  symbolInput.value = messageValue;
  // {% comment %} wrapper.querySelector('.cus_drw_cst_prd_blk_message_input').value = messageValue; {% endcomment %}
  closeDrawer();
	});

	const termsCheck = wrapper.querySelector('.cus_drw_cst_prd_blk_terms_check');
	if (termsCheck) {
	  termsCheck.addEventListener('change', function(){
	    confirmButton.disabled = !this.checked;
	  });
	}

});



// {% comment %} ---------------------------------------------------------size chart product page------------ {% endcomment %}

//   document.addEventListener('DOMContentLoaded', function(){
//   const wrapper = document.querySelector('.cus_sz_chrt_jsb__wrapper');
//   if(!wrapper) return;
//   const btn = wrapper.querySelector('.cus_sz_chrt_jsb__btn');
//   const popup = wrapper.querySelector('.cus_sz_chrt_jsb__popup');
//   const overlay = wrapper.querySelector('.cus_sz_chrt_jsb__overlay');
//   const close = wrapper.querySelector('.cus_sz_chrt_jsb__close');
//   btn.addEventListener('click', function(){
//     popup.classList.add('active');
//     overlay.classList.add('active');
//   });
//   function closePopup(){
//     popup.classList.remove('active');
//     overlay.classList.remove('active');
//   }
//   close.addEventListener('click', closePopup);
//   overlay.addEventListener('click', closePopup);

// });

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.cus_sz_chrt_jsb__wrapper');
  if (!wrapper) return;
  const btn = wrapper.querySelector('.cus_sz_chrt_jsb__btn');
  const popup = wrapper.querySelector('.cus_sz_chrt_jsb__popup');
  const overlay = wrapper.querySelector('.cus_sz_chrt_jsb__overlay');
  const close = wrapper.querySelector('.cus_sz_chrt_jsb__close');
  const ringFinder = wrapper.querySelector('.cus_sz_chrt_tbl__open');
  if (!btn || !popup || !overlay || !close) return;

  // open popup
  btn.addEventListener('click', function () {
    popup.classList.add('active');
    overlay.classList.add('active');
  });

  // close popup function
  function closePopup() {
    popup.classList.remove('active');
    overlay.classList.remove('active');
  }

  close.addEventListener('click', closePopup);
  overlay.addEventListener('click', closePopup);

  // ⭐ RING FINDER (PUT HERE)
  if (ringFinder) {
    ringFinder.addEventListener('click', function (e) {
      e.preventDefault();

      // close size chart popup
      closePopup();

      // open ring finder popup (scoped)
      setTimeout(() => {
        const wrapper = ringFinder.closest('.cus_sz_chrt_jsb__wrapper');
        const ringFinderPopup = wrapper.querySelector('.ring-finder-popup');

        if (ringFinderPopup) {
          ringFinderPopup.classList.add('active');
        }
      }, 200);
    });
  }

});

// ---------------------------------------------cus heaer menu newsletter drawer form------------------

document.addEventListener('DOMContentLoaded', function(){
    const trigger = document.querySelector('.cus_new_ltr_men_item');
    const drawer = document.querySelector('.cus_nwl_jsb_frm__drawer');
    const overlay = document.querySelector('.cus_nwl_jsb_frm__overlay');
    const closeBtn = document.querySelector('.cus_nwl_jsb_frm__close');
    if (!trigger || !drawer || !overlay || !closeBtn) return;

    function closeDrawer(){
      drawer.classList.remove('active');
      overlay.classList.remove('active');
    }

    trigger.addEventListener('click', function(){
      drawer.classList.add('active');
      overlay.classList.add('active');
    });

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
  });

  // ----------------------------------------------------custom-request-price---------------------

document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".cus_prd_req_pric_wrp");
  const popup = document.querySelector(".cus_request_price_overlay");
  const closeBtn = document.querySelector(".cus_request_price_close");
  if (!popup) return;
  let requestOpenedBy = null;

  function openRequestForm() {
    requestOpenedBy = document.activeElement;
    popup.classList.add("active");
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = "hidden";
    closeBtn?.focus({ preventScroll: true });
  }

  function closeRequestForm() {
    if (!popup.classList.contains('active')) return;
    popup.classList.remove("active");
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = "";
    requestOpenedBy?.focus({ preventScroll: true });
    requestOpenedBy = null;
  }

  // OPEN
  if (openBtn) {
    openBtn.addEventListener("click", openRequestForm);
  }
  // CLOSE button
  if (closeBtn) {
    closeBtn.addEventListener("click", closeRequestForm);
  }
  // CLICK OUTSIDE CLOSE
  popup.addEventListener("click", function (e) {
    if (e.target === popup) closeRequestForm();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeRequestForm();
  });
});

// Just Brilliant reveal header: hide on downward travel and return on upward travel.
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('#header.header');
  if (!header) return;

  let lastScroll = window.scrollY;
  let ticking = false;

  function showHeader() {
    header.classList.remove('jb-header-hidden');
    header.classList.add('jb-header-revealed');
  }

  function updateHeader() {
    const currentScroll = window.scrollY;
    const navigationIsOpen = document.querySelector('.jb-drawer.is-open, .jb-drawer.is-closing, .jb-search.is-open, .jb-right-panel.is-open');
    const movement = currentScroll - lastScroll;

    if (currentScroll <= 80) {
      header.classList.remove('jb-header-hidden', 'jb-header-revealed');
    } else if (navigationIsOpen) {
      showHeader();
    } else if (movement > 4) {
      header.classList.add('jb-header-hidden');
      header.classList.remove('jb-header-revealed');
    } else if (movement < -4) {
      showHeader();
    }

    lastScroll = currentScroll;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (ticking) return;
    window.requestAnimationFrame(updateHeader);
    ticking = true;
  }, { passive: true });

  document.addEventListener('jb:menu-open', showHeader);
  document.addEventListener('jb:menu-close', function () {
    lastScroll = window.scrollY;
  });
});

// ---------------------------------------------------custom product media gallery------------------------------

	document.addEventListener("DOMContentLoaded", function () {
      if (!window.matchMedia("(min-width: 1068px)").matches) return;
      const slider = document.querySelector(".custm_two_column_slder_list_container #Product-Slider");
      const prevBtn = document.querySelector(".custm_two_column_slder_list_container .slider-button--prev");
      const nextBtn = document.querySelector(".custm_two_column_slder_list_container .slider-button--next");
      const currentEl = document.querySelector(".custm_two_column_slder_list_container .slider-counter--current");
      const totalEl = document.querySelector(".custm_two_column_slder_list_container .slider-counter--total");

      if (!slider) return;

      const slides = slider.querySelectorAll(".custm_two_column_slder_list_container .product-images__slide");
      const totalSlides = slides.length;
      if (!totalSlides) return;

      let slideWidth = slides[0].offsetWidth;
      let currentIndex = 0;

      if (totalEl) totalEl.textContent = totalSlides;

      function updateSlider() {
        slideWidth = slides[0].offsetWidth;

        slider.scrollTo({
        left: currentIndex * slideWidth,
        behavior: "smooth"
        });

        if (currentEl) currentEl.textContent = currentIndex + 1;

        if (prevBtn) prevBtn.disabled = currentIndex === 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= totalSlides - 2;
      }

      prevBtn?.addEventListener("click", () => {
        if (currentIndex > 0) {
        currentIndex--;
        updateSlider();
        }
      });

      nextBtn?.addEventListener("click", () => {
        if (currentIndex < totalSlides - 2) {
        currentIndex++;
        updateSlider();
        }
      });

      let isDragging = false;
      let startX;
      let startScroll;

      slider.addEventListener("mousedown", (e) => {
        isDragging = true;
        slider.style.cursor = "grabbing";
        startX = e.pageX;
        startScroll = slider.scrollLeft;
      });

      document.addEventListener("mouseup", () => {
        if (!isDragging) return;

        isDragging = false;
        slider.style.cursor = "grab";

        currentIndex = Math.round(slider.scrollLeft / slideWidth);
        updateSlider();
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDragging) return;

        e.preventDefault();

        const walk = e.pageX - startX;
        slider.scrollLeft = startScroll - walk;
      });

      slider.addEventListener("touchend", () => {
        currentIndex = Math.round(slider.scrollLeft / slideWidth);
        updateSlider();
      });

      window.addEventListener("resize", updateSlider);

      updateSlider();

	});

  // -------------------------------------------------------------------product page add to cart show hide with variant price-----------------

//   document.addEventListener("change", () => {
//     setTimeout(() => {
//     const selected = document.querySelector('[id^="SelectedVariant"]');
//     const btn = document.querySelector('.cus_crt_add_btn_wrp');
//     if (!selected || !btn) return;
//     const variantId = selected.dataset.variantId;
//     const activeInput = document.querySelector('input:checked');
//     if (!activeInput) return;
//     const price = activeInput.getAttribute('cus-data-price');
//     btn.style.display = (price == "0" || price == 0) ? "none" : "block";
//    }, 100);
// });


// ---------------------------------------------------------------------------custom js size chart size guide------------------------------

document.addEventListener('DOMContentLoaded', function () {
    const popup = document.getElementById('cus_sz_chrt_tbl__popup');
    const closeBtn = document.getElementById('cus_sz_chrt_tbl__close');
    if (!popup) return;

    // Open popup from any button (even dynamically loaded)
    document.addEventListener('click', function(e) {
        if (e.target.closest('.cus_sz_chrt_tbl__open')) {
            popup.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    });

    function closePopup() {
        popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    if(closeBtn){
        closeBtn.addEventListener('click', closePopup);
    }

    popup.addEventListener('click', function(e) {
        if (e.target === popup) {
            closePopup();
        }
    });
});

// Provide one consistent keyboard escape route for custom drawers and overlays.
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  document.querySelectorAll(
    '.cus_drw_cst_prd_blk_drawer.active, .cus_drw_cst_prd_blk_overlay.active, ' +
    '.cus_sz_chrt_jsb__popup.active, .cus_sz_chrt_jsb__overlay.active, ' +
    '.cus_nwl_jsb_frm__drawer.active, .cus_nwl_jsb_frm__overlay.active, ' +
    '#cus_sz_chrt_tbl__popup.active'
  ).forEach((element) => element.classList.remove('active'));
  document.body.style.overflow = '';
});


// --------------------------------------------foooter bottom --------------------
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".cus_jstbrl_ftr_btm_item");
  items.forEach(item => {
    const title = item.querySelector(".has-submenu");
    if(title){
      title.addEventListener("click", function(){
        const isActive = item.classList.contains("active");
        items.forEach(i => i.classList.remove("active"));
        if(isActive) return;

        item.classList.add("active");
        setTimeout(() => {
          item.scrollIntoView({
            behavior: "smooth",
            block: "start"
          });
        }, 200);
      });
    }
  });
});
